/**
 * © 2026 Desktronic. All rights reserved.
 * Proprietary code. Unauthorized copying, distribution or use
 * without written permission from Desktronic is prohibited.
 * Source: desktronic.lt | desktronic.de | desktronic.se | desktronic.pl | desktronic.com/pl | desktronic.fr | desktronic.co.uk | desktronic.be | desktronic.nl | desktronic.dk | desktronic.com |  desktronic.cz
 */

// sig:dt-a7f3c91e04b2
$(function () {
  $('.plain-text').each(function () {
    var $section = $(this);
    var $content = $section.find('.plain-text__content');
    var $tocWrap = $section.find('.plain-text__toc-wrap');
    var $tocList = $section.find('.plain-text__toc-list');
    var $headings = $content.find('h2, h3, h4, h5');

    var $mobileToc = $section.find('.table-of-content-mobile');
    var $mobileTocList = $mobileToc.find('.table-of-content-mobile__list');
    var $body = $section.find('.plain-text__body');

    if (!$headings.length) {
      $tocWrap.remove();
      $mobileToc.remove();
      return;
    }

    var usedIds = {};

    $headings.each(function () {
      var $heading = $(this);
      var text = $heading.text().trim();
      var id = $heading.attr('id');

      if (!id) {
        id = text
          .toLowerCase()
          .replace(/[^a-z0-9ąčęėįšųūžäöüßåéèêëíóòôõñ]+/gi, '-')
          .replace(/^-+|-+$/g, '') || 'section';
        if (usedIds[id]) {
          usedIds[id] += 1;
          id = id + '-' + usedIds[id];
        } else {
          usedIds[id] = 1;
        }
        $heading.attr('id', id);
      }

      var level = this.tagName.toLowerCase();
      var $item = $('<li>', {
        'class': 'plain-text__toc-item plain-text__toc-item--' + level
      });
      var $link = $('<a>', {
        'class': 'plain-text__toc-link',
        href: '#' + id,
        text: text
      }).attr('data-toc-link', id);

      $item.append($link);
      $tocList.append($item);
    });

    $mobileTocList.append($tocList.clone());
    var tocMobile = deskTocMobileInit($mobileToc, $body);

    var $tocItems = $section.find('.plain-text__toc-item');
    var $tocLinks = $section.find('.plain-text__toc-link');
    var scrollOffset = 120;

    function getScrollOffset() {
      if (window.innerWidth >= 1280) return scrollOffset;
      return tocMobile.getOffset();
    }

    function scrollToHeading(id) {
      var target = document.getElementById(id);
      if (!target) return;
      var offset = getScrollOffset();
      if (window.lenis && typeof window.lenis.scrollTo === 'function') {
        window.lenis.scrollTo(target, { offset: -offset });
      } else {
        var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({ top: top, behavior: 'smooth' });
      }
      if (history.replaceState) {
        history.replaceState(null, '', '#' + id);
      }
    }

    $tocLinks.on('click', function (e) {
      e.preventDefault();
      scrollToHeading($(this).attr('data-toc-link'));
    });

    var headingEls = $headings.toArray();
    var ticking = false;

    function updateActive() {
      ticking = false;
      var offset = getScrollOffset();
      var current = headingEls[0];
      for (var i = 0; i < headingEls.length; i++) {
        if (headingEls[i].getBoundingClientRect().top - offset - 10 <= 0) {
          current = headingEls[i];
        } else {
          break;
        }
      }
      if (!current) return;
      var activeId = current.getAttribute('id');
      $tocItems.removeClass('is-active');
      $tocLinks.filter('[data-toc-link="' + activeId + '"]').closest('.plain-text__toc-item').addClass('is-active');
    }

    $(window).on('scroll resize', function () {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(updateActive);
      }
    });

    updateActive();

    if (window.location.hash) {
      var hashId = window.location.hash.slice(1);
      if (document.getElementById(hashId)) {
        setTimeout(function () {
          scrollToHeading(hashId);
        }, 100);
      }
    }
  });
});